<section class="container ids-mv-8">
  <article>
    <ids-icon size="XL" variant="success">confirmacao</ids-icon>
    <h2 class="title ids-text-title-01 ids-mv-5">{{ title }}</h2>
    <p class="ids-text-body-01">{{ text }}</p>
    <h3 class="subtitle ids-text-section-02 ids-pt-8">{{ subtitle }}</h3>
  </article>
</section>
